import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CART_ITEM from '../../../../../services/checkout/constants/cartItems';
import { getPhotoPricingPrintProduct } from '../../../../../services/checkout/redux/helpers';
import PrintProductIndividual from '../PrintProductIndividual';

const propTypes = {
  activeIdentity: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  selectedIdentity: PropTypes.shape({
    id: PropTypes.string,
  }),
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    prepaid_photo_print_packages_enabled: PropTypes.bool,
  }).isRequired,
  photoPricing: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  onPhotoPricingPrintProductToggle: PropTypes.func.isRequired,
  onPhotoPricingPrintProductUpdate: PropTypes.func.isRequired,
  cart: PropTypes.object.isRequired,
};

const PhotoPricingItemsSelector = ({
  activeIdentity,
  selectedIdentity,
  albumFolder,
  photoPricing,
  onPhotoPricingPrintProductToggle,
  onPhotoPricingPrintProductUpdate,
  cart,
}) => {
  if (!photoPricing || !albumFolder?.prepaid_photo_pricings_enabled) {
    return null;
  }

  const albumPrintPackageCartItems = cart.filter(item =>
    [CART_ITEM.ALBUM_PRINT_PACKAGE, CART_ITEM.PURCHASED_PRINT_PACKAGE].includes(
      item.type,
    ),
  );
  const hasPrintPackageCartItems = albumPrintPackageCartItems.length > 0;
  const canPurchasePhotoPrintItems =
    !photoPricing?.requires_package_purchase || hasPrintPackageCartItems;

  const photoPricingPrintProducts =
    photoPricing?.print_product_items?.records ?? [];

  return (
    <Fragment>
      <h4 className="mt-2">Individual Prints &amp; Products</h4>

      {photoPricingPrintProducts.map(photoPricingPrintProduct => (
        <PrintProductIndividual
          photoPricingPrintProductItem={photoPricingPrintProduct}
          cartItem={getPhotoPricingPrintProduct(cart, {
            photoPricingPrintProductId: photoPricingPrintProduct?.id,
            identityId: activeIdentity?.id,
            prePaid: true,
          })}
          onCartItemToggle={({ accountCard, roesConfiguration }) => {
            onPhotoPricingPrintProductToggle({
              accountCard,
              roesConfiguration,
              photoPricingPrintProduct,
              identity: activeIdentity,
              album: selectedIdentity?.album_membership?.album,
              albumFolder,
              photoPricing,
              prePaid: true,
            });
          }}
          onCartItemUpdate={onPhotoPricingPrintProductUpdate}
          disabled={!canPurchasePhotoPrintItems}
          disabledElement={
            <span className="purchasing-option-item-info-requires-package">
              Requires the purchase of a print package first.
            </span>
          }
        />
      ))}
    </Fragment>
  );
};

PhotoPricingItemsSelector.propTypes = propTypes;

export default PhotoPricingItemsSelector;
